// Copyright (c) StrangeBee 2024

import client from '@Client';

export const getFileDatastoreUrl = (fileId: string): string =>
    `${client.apiUrl}/datastore/${encodeURIComponent(fileId)}`;

export const getAvatarUrl = (avatar: string): string => `${client.apiUrl}${avatar.replace('api', '')}`;
